import React from 'react'

const Result = ({ restart }) => {


        return (
            
            <div>
                <p className="progress">Prediction Error</p>
                <div className="error-container">
                    <p>Oops! There's been a bit of a mixup...</p>
                    <p>Sorry about that!</p>
                    <button onClick={restart}>Try again</button>
                </div>
            </div>
        )


}

export default Result